import React from "react";

const BingoTable = ({ drawnNumbers, size = 3 }) => {
  const numbers = generateBingoNumbers();

  // Validate size input (1 to 5)
  const validSize = Math.min(Math.max(size, 1), 5);

  // Define a granular set of font-size classes from 1 to 5
  const fontSizeClasses = [
    "text-sm",  // size 1
    "text-xl",  // size 2
    "text-2xl", // size 3
    "text-4xl", // size 4
    "text-6xl", // size 5
  ];

  // Map validSize to corresponding font-size class
  const fontSizeClass = fontSizeClasses[validSize - 1];

  return (
    <div className="w-full h-full flex items-center justify-center p-4">
      <div className="w-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="grid grid-cols-5 bg-gradient-to-r from-blue-600 to-indigo-700 text-white">
          {["B", "I", "N", "G", "O"].map((column) => (
            <div 
              key={column} 
              className={`text-center py-4 ${fontSizeClass} font-black uppercase tracking-widest border-r last:border-r-0 border-white/20`}
            >
              {column}
            </div>
          ))}
        </div>

        {/* Bingo Grid */}
        <div className="grid grid-cols-5">
          {transposeBingoNumbers(numbers).map((row, rowIndex) => (
            row.map((num, columnIndex) => (
              <div
                key={`${rowIndex}-${columnIndex}`}
                className={`
                  flex items-center justify-center ${fontSizeClass} font-bold border 
                  border-gray-200 transition-all duration-300
                  ${num && drawnNumbers.includes(num) 
                    ? 'bg-green-500 text-white shadow-inner' 
                    : 'bg-white text-gray-800 hover:bg-gray-100'}
                `}
              >
                {num || ""}
              </div>
            ))
          ))}
        </div>
      </div>
    </div>
  );
};

// Helper: Generate numbers for B, I, N, G, O columns
const generateBingoNumbers = () => {
  return [
    Array.from({ length: 15 }, (_, i) => i + 1), // B: 1-15
    Array.from({ length: 15 }, (_, i) => i + 16), // I: 16-30
    Array.from({ length: 15 }, (_, i) => i + 31), // N: 31-45
    Array.from({ length: 15 }, (_, i) => i + 46), // G: 46-60
    Array.from({ length: 15 }, (_, i) => i + 61), // O: 61-75
  ];
};

// Helper: Transpose columns to rows for table rendering
const transposeBingoNumbers = (columns) => {
  const maxLength = Math.max(...columns.map((col) => col.length));
  return Array.from({ length: maxLength }, (_, rowIndex) =>
    columns.map((col) => col[rowIndex] || null)
  );
};

export default BingoTable;
